<template>
    <div class="container-fluid publicLayout" id="body-content">
        <section class="publicLayout__hero">
            <div class="publicLayout__logo-wrap">
                <img
                    class="publicLayout__logo"
                    src="assets/images/Logo_Elroble.png"
                    alt="Seguros El Roble"
                >
            </div>
            <h1 class="publicLayout__title">Pago en Línea de Pólizas</h1>
            <p class="publicLayout__desc">
                Consulta tu póliza y todos los datos importantes que necesitas. A través de este sitio podrás pagar los requerimientos de pago asociados a tu póliza de seguro.
            </p>
            <div class="publicLayout__illustration-wrap">
                <img
                    class="publicLayout__illustration"
                    src="assets/images/portadacobros.png"
                    alt="Pago en línea con tarjeta"
                >
            </div>
        </section>
        <section class="publicLayout__main">
            <slot></slot>
        </section>
    </div>
</template>

<script>

import {mapGetters, mapMutations} from "vuex";
import API from "src/core/Api";
import {store} from "src/store";
import AndroidBridge from "src/core/AndroidBridge";
import {CONFIG} from "src/config";
import Tools from "src/core/Tools";

export default {
    props: {},
    components: {},
    data() {
        return {
            androidBridge: false,
            isOnApp: false,
            showConfig: false,
            userInfo: {},
            version: "",
        };
    },
    mounted() {
        this.version = CONFIG.getVersion();
        this.userInfo = this.AuthGetUserInfo();
        this.androidBridge = new AndroidBridge();
        this.isOnApp = this.androidBridge.appEnabled();

        if (CONFIG.getEnvironment() !== 'PRODUCTION') {
            document.getElementById('body-content').style.background = '#ffddcf';
        }

        this.showConfig = Tools.checkAccess('configuracion/pos');
    },
    methods: {
        ...mapGetters(["AuthGetUserInfo"]),
        ...mapMutations(["Logout"]),
        goTo(dir) {
            this.$router.push(dir);
            this.toogleBar();
        },
    },
};
</script>
